import React from 'react'
import { Button, Flex, Text, useAppTheme } from '@workwhile/ui'
import { Link } from 'react-router-dom'
import { X } from 'lucide-react'
import { useRuleDetailContextValue } from '../context/RuleDetailProvider'
import * as ROUTES from 'constants/routes'
import { formatJurisdictionLabel } from './JurisdictionList.utils'

type JurisdictionMap = Map<
  number,
  ReturnType<typeof useRuleDetailContextValue>['state']['jurisdictions'][number]
>

export const JurisdictionList = ({
  jurisdictionIds,
  jurisdictionMap,
  onDetach,
}: {
  jurisdictionIds: number[]
  jurisdictionMap: JurisdictionMap
  onDetach: (jurisdictionId: number) => void
}) => {
  const { radii } = useAppTheme()

  return (
    <Flex flexDirection="column" p={3} gap={2}>
      {jurisdictionIds.map((id, index) => {
        const j = jurisdictionMap.get(id)
        return (
          <Flex
            key={`wage-rule-detail-link-${id}`}
            border="1px solid"
            borderColor="neutrals.100"
            p={3}
            borderRadius={radii.standard}
            width="100%"
            alignItems="center"
            justifyContent="space-between"
            mb={index === jurisdictionIds.length - 1 ? 0 : 2}
          >
            <Link
              to={ROUTES.WAGE_JURISDICTION_DETAIL.replace(
                ':jurisdictionId',
                String(id)
              )}
            >
              <Text color="primary">
                {j ? formatJurisdictionLabel(j) : `#${id}`}
              </Text>
            </Link>
            <Button variant="text" kind="small" onClick={() => onDetach(id)}>
              <X size={14} />
            </Button>
          </Flex>
        )
      })}
    </Flex>
  )
}
